  import React, { useEffect, useRef, useState } from 'react';
    import { createRoot } from 'react-dom/client';
    import CloseIcon from '@mui/icons-material/Close';
    import NtactLogo from '../assets/NTACT Logo.svg';
    import { Document, Link, Page, Text, View, StyleSheet, Image, PDFViewer } from '@react-pdf/renderer';
import LOgo from '../assets/Ntact.png'
    
import { testjson } from './accidentinvestigation.jsx/testjson';
import { Backdrop, CircularProgress } from '@mui/material';
import api from '../api/api';
import { Buffer } from "buffer";
window.Buffer = Buffer;

const styles = StyleSheet.create({
   page: {
    padding: 25,
    fontSize: 13,
    fontFamily: 'Helvetica',
    flexDirection: 'column',
  },
    subSectionTitle: {
    fontSize: 15,
    fontWeight: '600',
    marginBottom: 8,
    color: '#333',
  },
   imageContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 10,
    marginTop: 10,
  },
  imageWrapper: {
    width: '30%',
    height: 150,
    marginBottom: 10,
    objectFit: 'cover',
    backgroundColor: '#eee',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  imageFilename: {
    fontSize: 11,
    textAlign: 'center',
    marginTop: 5,
    marginBottom: 5,
    color: '#555',
  },
  header: {
    flexDirection: 'column',
    alignItems: 'center',
    borderBottom: '1px solid #71717A',
    paddingBottom: 12,
    marginBottom: 18,
  },
  logo: {
    width: 80,
    height: 50,
    marginBottom: 10,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#900',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 12,
    color: '#71717A',
    textAlign: 'center',
  },
  section: {
    marginBottom: 15,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 6,
    gap: 8,
  },
  column: {
    flex: 1,
    flexDirection: 'column',
    gap: 5,
  },
  label: {
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: 3,
    textAlign: 'left',
  },
  value: {
    border: '1px solid #9CA3AF',
    padding: 5,
    borderRadius: 4,
    textAlign: 'left',
    minHeight: 22,
    fontSize: 12,
    backgroundColor: '#FFFFFF',
  },
  checkboxContainer: {
    flexDirection: 'row',
    gap: 6,
    flexWrap: 'wrap',
  },
  checkboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  checkbox: {
    width: 12,
    height: 12,
    border: '1px solid #9CA3AF',
    borderRadius: 2,
  },
  checked: {
    width: 12,
    height: 12,
    border: '1px solid #18181B',
    backgroundColor: '#18181B',
    borderRadius: 2,
  },
 grid: {
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: 10,
},
gridItem: {
  width: '22%',
},

  textarea: {
    border: '1px solid #9CA3AF',
    padding: 6,
    borderRadius: 4,
    textAlign: 'left',
    minHeight: 60,
    fontSize: 12,
  },
  borderTop: {
    borderTop: '1px solid #E5E7EB',
    paddingTop: 10,
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    marginBottom: 6,
    textAlign: 'left',
  },
   sectionBox: {
    border: '1px solid #E5E7EB',
    padding: 15,
    borderRadius: 6,
    backgroundColor: '#FFFFFF',
    marginBottom: 15,
  },
  sectionHeading: {
    fontSize: 15,
    fontWeight: 'bold',
    marginBottom: 12,
    textAlign: 'left',
  },
  textRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 10,
    marginBottom: 10,
  },
  halfWidth: {
    width: '48%',
  },
  fullWidth: {
    width: '100%',
  },
  diagramWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 15,
    marginTop: 10,
  },
  diagramLabel: {
    fontWeight: 'bold',
    marginBottom: 5,
    textAlign: 'left',
  },
  diagramImage: {
    width: 200,
    height: 200,
    objectFit: 'contain',
    backgroundColor: '#F3F4F6',
    borderRadius: 4,
  },
  diagramImag: {
    width: 100,
    height: 100,
    objectFit: 'contain',
    backgroundColor: '#F3F4F6',
    borderRadius: 4,
  },
});
const pdfStyles = StyleSheet.create({
  pageLayout: {
    padding: 30,
    fontFamily: 'Helvetica',
    fontSize: 13,
    color: '#18181B',
  },
  headerBlock: {
    flexDirection: 'column',
    alignItems: 'center',
    borderBottom: '1px solid #71717A',
    paddingBottom: 12,
    marginBottom: 18,
  },
  logoImage: {
    width: 80,
    height: 80,
  },
  titleText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#900',
    textAlign: 'center',
  },
  subtitleText: {
    fontSize: 12,
    color: '#71717A',
    textAlign: 'center',
  },
  contentArea: {
    marginBottom: 15,
  },
  flexRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
    gap: 10,
  },
  fieldContainer: {
    flexDirection: 'column',
    marginBottom: 6,
  },
  fieldLabel: {
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: 3,
    textAlign: 'left',
  },
  fieldValue: {
    border: '1px solid #9CA3AF',
    padding: 5,
    borderRadius: 4,
    textAlign: 'left',
    minHeight: 22,
    backgroundColor: '#FFFFFF',
    fontSize: 12,
  },
  checkboxGroup: {
    flexDirection: 'column',
    gap: 6,
  },
  checkboxItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  uncheckedBox: {
    width: 12,
    height: 12,
    border: '1px solid #9CA3AF',
    borderRadius: 2,
  },
  checkedBox: {
    width: 12,
    height: 12,
    border: '1px solid #18181B',
    backgroundColor: '#18181B',
    borderRadius: 2,
  },
  gridLayout: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  gridElement: {
    width: '30%',
  },
  longTextArea: {
    border: '1px solid #9CA3AF',
    padding: 8,
    borderRadius: 4,
    textAlign: 'left',
    minHeight: 80,
    lineHeight: 1.4,
    fontSize: 12,
    flexWrap: 'wrap',
  },
  topBorder: {
    borderTop: '1px solid #E5E7EB',
    paddingTop: 10,
  },
  sectionHeading: {
    fontSize: 15,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'left',
  },
   sectionBox: {
    border: '1px solid #E5E7EB',
    padding: 15,
    borderRadius: 6,
    backgroundColor: '#FFFFFF',
    marginBottom: 15,
  },
  sectionHeading: {
    fontSize: 15,
    fontWeight: 'bold',
    marginBottom: 12,
    textAlign: 'left',
  },
  textRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 10,
    marginBottom: 10,
  },
  halfWidth: {
    width: '48%',
  },
  fullWidth: {
    width: '100%',
  },
  diagramWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 15,
    marginTop: 10,
  },
  diagramLabel: {
    fontWeight: 'bold',
    marginBottom: 5,
    textAlign: 'left',
  },
  diagramImage: {
    width: 200,
    height: 200,
    objectFit: 'contain',
    backgroundColor: '#F3F4F6',
    borderRadius: 4,
  },
});
const PDF_IMAGE = {
  thumbnail: {
    width: 120,
    height: 120,
  },
  signature: {
    width: 180,
    height: 50,
  },
  smallPreview: {
    width: 90,
    height: 65,
  },
};
const ORIGINAL_BASE_URL =
  "https://hub2.ntactops.com/ntact/public/assets/forms_files/";

const withProxy = (url) =>
  url ? `/proxy?url=${encodeURIComponent(url)}` : null;

    const PDFDocument = ({ data,
  diagramImages,
  employeeSignatureImgs,
  witnessSignatureImgs,
  supimg,
  empsignimg,
  imagesarray,
  employeeStatementImgs,
  witnessStatementImgs,
  photoStatementImgs}) => (
     <Document>
    <Page size="A4"  style={styles.page}>
      {/* Header */}
      <View style={styles.header} wrap={false}>
        <Image src={LOgo} style={styles.logo} />
        <Text style={styles.title}>Accident/Incident Investigation Form</Text>
        <Text style={styles.subtitle}>NTACT Operations - Must be completed within 24 hours</Text>
      </View>
<View style={styles.section} wrap={false}>
  <View style={styles.row}>
    <View style={styles.column}>
      <Text style={styles.label}>Name of Employee</Text>
      <Text style={styles.value}>{data?.employeename || '-'}</Text>
    </View>
    <View style={styles.column}>
      <Text style={styles.label}>Employee/Badge #</Text>
      <Text style={styles.value}>{data?.employeebadge || '-'}</Text>
    </View>
    <View style={styles.column}>
      <Text style={styles.label}>Phone Number</Text>
      <Text style={styles.value}>{data?.phonenumber || '-'}</Text>
    </View>
    <View style={styles.column}>
      <Text style={styles.label}>Address</Text>
      <Text style={styles.value}>{data?.address || '-'}</Text>
    </View>
  </View>

  <View style={styles.row}>
    <View style={styles.column}>
      <Text style={styles.label}>City</Text>
      <Text style={styles.value}>{data?.city || '-'}</Text>
    </View>
    <View style={styles.column}>
      <Text style={styles.label}>State</Text>
      <Text style={styles.value}>{data?.state || '-'}</Text>
    </View>
    <View style={styles.column}>
      <Text style={styles.label}>Zip</Text>
      <Text style={styles.value}>{data?.zipcode || '-'}</Text>
    </View>
    <View style={styles.column}>
      <Text style={styles.label}>Time of Incident</Text>
      <Text style={styles.value}>
        {data.incidentdate
          ? new Date(data.incidentdate).toLocaleString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
          : "-"}
      </Text>
    </View>
  </View>
</View>


      {/* Department */}
      <View style={[styles.section, styles.borderTop]} wrap={false}>
        <Text style={[styles.label,{marginBottom: 5}]}>Department</Text>
        <View style={styles.checkboxContainer}>
          {data?.department?.values?.map((option) => {
            const isSelected = data.department.selectedValue === option;
            return (
              <View key={option} style={styles.checkboxRow}>
                <View style={isSelected ? styles.checked : styles.checkbox} />
                <Text>{option}</Text>
              </View>
            );
          })}
        </View>
      </View>

      {/* Job Info */}
      <View style={styles.row}>
        <View style={styles.column}>
          <Text style={styles.label}>Job Title</Text>
          <Text style={styles.value}>{data?.jobtitle || '-'}</Text>
        </View>
        <View style={styles.column}>
          <Text style={styles.label}>Project Number</Text>
          <Text style={styles.value}>{data?.projectnumber || '-'}</Text>
        </View>
        <View style={styles.column}>
          <Text style={styles.label}>Project Location</Text>
          <Text style={styles.value}>{data?.projectlocation || '-'}</Text>
        </View>
      </View>

      {/* Additional Info */}
      <View style={styles.row}>
        <View style={styles.column}>
          <Text style={styles.label}>Client</Text>
          <Text style={styles.value}>{data?.client || '-'}</Text>
        </View>
        <View style={styles.column}>
          <Text style={styles.label}>Weather Condition</Text>
          <Text style={styles.value}>{data?.wheathercondition || '-'}</Text>
        </View>
        <View style={styles.column}>
          <Text style={styles.label}>Direct Supervisor</Text>
          <Text style={styles.value}>{data?.directsupervisor || '-'}</Text>
        </View>
      </View>
           <View style={[styles.section, styles.borderTop]}>
        <Text style={[styles.label,{marginBottom: 5}]}>Client Been Notified</Text>
        <View style={styles.checkboxContainer}>
          {data?.clientbeennotified?.values?.map((option) => {
            const isSelected = data.clientbeennotified.selectedValue === option;
            return (
              <View key={option} style={styles.checkboxRow}>
                <View style={isSelected ? styles.checked : styles.checkbox} />
                <Text>{option}</Text>
              </View>
            );
          })}
        </View>
      </View>
   <View style={[styles.section, styles.borderTop]} wrap={false}>
        <Text style={[styles.label,{marginBottom: 5}]}>Classification (Check all that apply)</Text>
        <View style={styles.grid}>
          {data?.damages?.options?.map((option) => {
            const isChecked = data.damages.selectedValues.includes(option);
            return (
              <View key={option} style={styles.gridItem}>
                <View style={styles.checkboxRow}>
                  <View style={isChecked ? styles.checked : styles.checkbox} />
                  <Text>{option}</Text>
                </View>
              </View>
            );
          })}
        </View>
      </View>
      {/* Client Been Notified */}
 

     



      {/* Injured Side */}
      <View style={[styles.section, styles.borderTop]} wrap={false}>
        <Text style={[styles.label,{marginBottom: 5}]}>Injured Side</Text>
        <View style={styles.checkboxContainer}>
          {data?.injuredside?.options?.map((option) => {
            const isSelected = data.injuredside.selectedValue === option;
            return (
              <View key={option} style={styles.checkboxRow}>
                <View style={isSelected ? styles.checked : styles.checkbox} />
                <Text>{option}</Text>
              </View>
            );
          })}
        </View>
      </View>

      {/* Body Parts Injured */}
      <View style={[styles.section, styles.borderTop]} wrap={false}>
        <Text style={[styles.label,{marginBottom: 5}]}>Body Parts Injured (Check all that apply)</Text>
        <View style={styles.grid}>
          {data?.bodypartsinjuried?.options?.map((option) => {
            const isChecked = data.bodypartsinjuried.selectedValues.includes(option);
            return (
              <View key={option} style={styles.gridItem}>
                <View style={styles.checkboxRow}>
                  <View style={isChecked ? styles.checked : styles.checkbox} />
                  <Text>{option}</Text>
                </View>
              </View>
            );
          })}
        </View>
      </View>
<View
   
      style={{ border: '1px solid #9CA3AF', padding: 15, borderRadius: 4, marginBottom: 10 }}
      wrap={false}
    >
      <Text style={styles.sectionTitle}> Post-Accident Drug & Alcohol Testing</Text> 
      {/* Post-Accident UA and Test Type */}
      <View style={[styles.row, styles.borderTop]}>
        <View style={styles.column}>
          <Text style={styles.label}>Post-Accident UA</Text>
          <View style={styles.checkboxContainer}>
            {data?.postaccidentua?.options?.map((option) => {
              const isChecked = data.postaccidentua.selectedValues.includes(option);
              return (
                <View key={option} style={styles.checkboxRow}>
                  <View style={isChecked ? styles.checked : styles.checkbox} />
                  <Text>{option}</Text>
                </View>
              );
            })}
          </View>
        </View>
        <View style={styles.column}>
          <Text style={styles.label}>Test Type</Text>
          <View style={styles.checkboxContainer}>
            {data?.testtype?.selectedvalue}
          </View>
        </View>
      </View>

      {/* Facility and Collector */}
      <View style={styles.row}>
        <View style={styles.column}>
          <Text style={styles.label}>Facility</Text>
          <Text style={styles.value}>{'Sample Facility'}</Text>
        </View>
        <View style={styles.column}>
          <Text style={styles.label}>Collector</Text>
          <Text style={styles.value}>{'Sample Collector'}</Text>
        </View>
      </View>
</View>
 {/* Employee Signature */}
      <View style={styles.row}>
        <View style={styles.column}>
          <Text style={styles.label}>Employee Name (Print)</Text>
          <Text style={styles.value}>{data?.employeenameprint || ''}</Text>
        </View>
        {data?.employeenameprintsignature&&<View style={styles.column}>
          <Text style={styles.label}>Signature</Text>
          <Text style={styles.value}>{data?.employeenameprintsignature || ''}</Text>
        </View>}
        <View style={styles.column}>
          <Text style={styles.label}>Date</Text>
          <Text style={styles.value}>
            {data?.employeenameprintsignaturedate
              ? new Date(data.employeenameprintsignaturedate + "T00:00:00").toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })
              : ''}
          </Text>
        </View>
      </View>
         {empsignimg?.base64_data && (
  <View style={[styles.section, styles.borderTop]} wrap={false}>
    <Text style={styles.sectionTitle}>Employee Signature</Text>
    <Image
      src={empsignimg.base64_data}
      style={{
        width: 160,
        height: 40,
        objectFit: 'contain',
        border: '1px solid #ccc',
      }}
    />
  </View>
)}
{/* Supervisor Details */}
<View style={[styles.section, styles.borderTop]} wrap={false}>
  <View style={styles.row}>
    <View style={styles.column}>
      <Text style={styles.label}>Supervisor Name (Print)</Text>
      <Text style={styles.value}>{data?.supervisornameprint || ''}</Text>
    </View>

    {data?.supervisorprintsignature && (
      <View style={styles.column}>
        <Text style={styles.label}>Signature</Text>
        <Text style={styles.value}>{data?.supervisorprintsignature}</Text>
      </View>
    )}

    <View style={styles.column}>
      <Text style={styles.label}>Date</Text>
      <Text style={styles.value}>
        {data?.supervisorprintsignaturedate
          ? new Date(
              data.supervisorprintsignaturedate + 'T00:00:00'
            ).toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            })
          : ''}
      </Text>
    </View>
  </View>
</View>

{/* Supervisor Signature */}
{supimg?.base64_data && (
  <View style={[styles.section, styles.borderTop]} wrap={false}>
    <Text style={styles.sectionTitle}>Supervisor Signature</Text>

    <Image
      src={supimg.base64_data}
      style={{
        width: 160,
        height: 40,
        objectFit: 'contain',
        border: '1px solid #ccc',
        borderRadius: 4,
        marginTop: 6,
        backgroundColor: '#fff',
        alignSelf: 'flex-start',
      }}
    />
  </View>
)}

      <View style={[styles.section, styles.borderTop]}>
  <Text style={styles.sectionTitle}>Incident Details</Text>

  {/* Enter Manually Checkbox */}
  {/* <View style={styles.row} wrap={false}>
    <View style={styles.column}>
      <Text style={styles.label}>Enter Manually</Text>
      <Text style={styles.value}>{data?.enterManually ? 'Yes' : 'No'}</Text>
    </View>
  </View> */}

 <View style={{ marginVertical: 10 }}>
  {/* Accident Description */}
  <View style={{ marginBottom: 10 }} wrap={false}>
    <Text style={{ fontWeight: 'bold', fontSize: 13, marginBottom: 2 }}>Accident Description</Text>
    <Text style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>
      Detailed description of what happened
    </Text>
    <Text style={{ fontSize: 12, color: '#000' }}>
      {data?.descriptionofincident || '-'}
    </Text>
  </View>

  {/* Incident Causes */}
  <View style={{ marginBottom: 10 }} wrap={false}>
    <Text style={{ fontWeight: 'bold', fontSize: 13, marginBottom: 2 }}>Incident Causes</Text>
    <Text style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>
      What caused this incident?
    </Text>
    <Text style={{ fontSize: 12, color: '#000' }}>
      {data?.incidentDescription || '-'}
    </Text>
  </View>

  {/* Incident Summary */}
  <View style={{ marginBottom: 10 }} wrap={false}>
    <Text style={{ fontWeight: 'bold', fontSize: 13, marginBottom: 2 }}>Incident Summary</Text>
    <Text style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>
      Summary of incident
    </Text>
    <Text style={{ fontSize: 12, color: '#000' }}>
      {data?.incidentsummary || '-'}
    </Text>
  </View>
</View>

</View>

{/* WITNESS INFORMATION */}
<View style={[styles.section, styles.borderTop]}>
  <View wrap={false}>
    <Text style={styles.sectionTitle}>Witness Information</Text>

    {/* Any Witness */}
    <View style={styles.row}>
      <View style={styles.column}>
        <Text style={styles.label}>Were there any witnesses?</Text>
        <Text style={styles.value}>{data?.anyWitness === 'Yes' ? 'Yes' : 'No'}</Text>
      </View>
    </View>
  </View>

  {/* Witness Cards */}
  {(data?.witnessCards || []).map((witness, index) => (
    <View key={index} style={[styles.card, styles.marginTop]} wrap={false}>
      <Text style={styles.subSectionTitle}>Witness {index + 1}</Text>

      <View style={styles.row}>
        <View style={styles.column}>
          <Text style={styles.label}>Name</Text>
          <Text style={styles.value}>{witness.name || '-'}</Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={styles.column}>
          <Text style={styles.label}>Phone Number</Text>
          <Text style={styles.value}>{witness.phone || '-'}</Text>
        </View>
      </View>
    </View>
  ))}
</View>
       <View
  style={{ marginBottom: 12, paddingTop: 10, borderTop: '1px solid #ccc' }}
>
  <Text style={{ fontSize: 14, fontWeight: 600, marginBottom: 6 }}>
    Attachments (Files uploaded)
  </Text>

  {data?.attachments?.options?.map((option) => {
    const files = data.attachments.Files?.[option] || [];
    const isSelected = data.attachments.selectedvalues.includes(option);

    return (
      <View key={option} style={{ marginBottom: 12 }}>
        {/* Option Title + Checkbox */}
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 6,
          }}
        >
          <View
            style={{
              width: 12,
              height: 12,
              borderWidth: 1,
              borderColor: '#000',
              backgroundColor: isSelected ? '#000' : '#fff',
              marginRight: 6,
            }}
          />
          <Text style={{ fontSize: 12 }}>{option}</Text>
        </View>

        {/* Files */}
        {files.length > 0 && (
          <View
            style={{
              marginLeft: 18,
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: 8,
            }}
          >
            {files.map((file, idx) => {
              const fileName = file.file_name;

              const originalUrl =
                'https://hub2.ntactops.com/ntact/files/forms_files/' +
                fileName;

              const finalUrl =
                'https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=' +
                encodeURIComponent(originalUrl);

              const isImage = /\.(jpg|jpeg|png|gif|heic|heif|webp|bmp)$/i.test(
                fileName
              );
              const isPDF = /\.pdf$/i.test(fileName);

              return (
                <View
                  key={idx}
                    wrap={false}
                  style={{
                    width: 150,
                    padding: 6,
                    border: '1px solid #ccc',
                    borderRadius: 4,
                    alignItems: 'center',
                    marginRight: 8,
                    marginBottom: 12,
                    flexDirection: 'column',
                  }}
                >
                  {/* IMAGE */}
                  {isImage && (
                    <Image
                      src={finalUrl}
                      style={{
                        width: 120,
                        height: 120,
                        objectFit: 'cover',
                        borderRadius: 4,
                        marginBottom: 4,
                      }}
                    />
                  )}

                  {/* PDF */}
                  {isPDF && (
                    <View
                      style={{
                        width: 62,
                        height: 62,
                        backgroundColor: '#ffe5e5',
                        borderRadius: 4,
                        border: '1px solid #ff0000',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: 4,
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 12,
                          color: '#cc0000',
                          fontWeight: 700,
                        }}
                      >
                        PDF
                      </Text>
                    </View>
                  )}

                  {/* OTHER FILE TYPES */}
                  {!isImage && !isPDF && (
                    <View
                      style={{
                        width: 62,
                        height: 62,
                        backgroundColor: '#f0f0f0',
                        borderRadius: 4,
                        border: '1px solid #999',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: 4,
                      }}
                    >
                      <Text style={{ fontSize: 10, color: '#444' }}>
                        FILE
                      </Text>
                    </View>
                  )}

                  {/* FILE NAME */}
                {/* FILE NAME */}
<View style={{ width: 120, marginTop: 2 }}>
  {isImage && (
    <Link src={finalUrl}>
      <Text
        style={{
          fontSize: 7,
          textAlign: 'center',
          textDecoration: 'underline',
          color: 'blue',
        }}
      >
        {fileName.match(/.{1,18}/g)?.join('\n')}
      </Text>
    </Link>
  )}
</View>
                </View>
              );
            })}
          </View>
        )}
      </View>
    );
  })}
</View>

      {/* Incident Summary */}
      <View style={[styles.section, styles.borderTop]} wrap={false}>
      <Text style={{ ...styles.label, marginBottom: 2 }} >Incident Summary</Text>
        <Text style={styles.textarea}>{data?.incidentsummary || 'Enter a brief summary of the incident'}</Text>
      </View>

     

      {/* Employee Statements — reference style: header table + large image */}
<View style={[styles.section, styles.borderTop]}>
      {data?.employeeStatements?.map((statement, index) => {
    const empImgs = data?.employeeStatementImgs?.[index] || [];
    const hasImages = empImgs.length > 0;

    return (
    <View key={index} style={{ border: '1px solid #333', marginBottom: 10 }}>
      {/* Title */}
      <View style={{ borderBottom: '1px solid #333', paddingVertical: 5, paddingHorizontal: 8, backgroundColor: '#f3f4f6' }}>
        <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'center' }}>Statement of Employee</Text>
      </View>

      {/* Header row: Job Title | Time in Craft | Time on Jobsite */}
      <View style={{ flexDirection: 'row', borderBottom: '1px solid #333' }}>
        <View style={{ flex: 2, borderRight: '1px solid #333', paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Job Title:</Text>
          <Text style={{ fontSize: 11, fontWeight: 'bold' }}>{statement.jobTitle || '-'}</Text>
        </View>
        <View style={{ flex: 1, borderRight: '1px solid #333', paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Time in Craft:</Text>
          <Text style={{ fontSize: 11, fontWeight: 'bold' }}>{statement.timeInCraft || '-'}</Text>
        </View>
        <View style={{ flex: 1, paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Time on Jobsite:</Text>
          <Text style={{ fontSize: 11, fontWeight: 'bold' }}>{statement.timeOnJobsite || '-'}</Text>
        </View>
      </View>

      {/* Description of Accident / Incident heading */}
      <View style={{ borderBottom: '1px solid #333', paddingVertical: 4, paddingHorizontal: 8 }}>
        <Text style={{ fontSize: 12, fontWeight: 'bold', textAlign: 'center' }}>Description of Accident / Incident</Text>
      </View>

      {/* If images exist, show large — like handwritten statement scan */}
      {hasImages ? (
        <View style={{ padding: 6 }}>
          {empImgs.map((img, i) => {
            const imageUrl = img?.file_name
              ? `https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=${encodeURIComponent(
                  `https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`
                )}`
              : null;
            return imageUrl ? (
              <Image key={i} src={imageUrl} style={{ width: '100%', height: 500, objectFit: 'contain', marginBottom: 6 }} />
            ) : null;
          })}
        </View>
      ) : (
        <View style={{ padding: 8, minHeight: 80 }}>
          <Text style={{ fontSize: 11 }}>{statement.description || '-'}</Text>
        </View>
      )}

      {/* Bottom: Name | Signature | Date */}
      <View style={{ flexDirection: 'row', borderTop: '1px solid #333' }}>
        <View style={{ flex: 1, borderRight: '1px solid #333', paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Name:</Text>
          <Text style={{ fontSize: 11, fontWeight: 'bold' }}>{statement.name || '-'}</Text>
        </View>
        <View style={{ flex: 1, borderRight: '1px solid #333', paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Signature:</Text>
          {employeeSignatureImgs?.[index]?.map((img, i) => (
            <Image key={i} src={img?.preview?.base64_data} style={{ width: 120, height: 30, objectFit: 'contain', marginTop: 2 }} />
          ))}
        </View>
        <View style={{ flex: 1, paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Date:</Text>
          <Text style={{ fontSize: 11, fontWeight: 'bold' }}>{statement.date || '-'}</Text>
        </View>
      </View>
    </View>
    );
  })}
</View>
      {/* Witness Statements — reference style: header table + large image */}
<View style={[styles.section, styles.borderTop]}>
  {data?.witnessStatements?.map((statement, index) => {
    const witImgs = data?.witnessStatementImgs?.[index] || [];
    const hasImages = witImgs.length > 0;

    return (
    <View key={index} wrap={false} style={{ border: '1px solid #333', marginBottom: 10 }}>
      {/* Title */}
      <View style={{ borderBottom: '1px solid #333', paddingVertical: 5, paddingHorizontal: 8, backgroundColor: '#f3f4f6' }}>
        <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'center' }}>Witness Statement</Text>
      </View>

      {/* Header row: Job Title | Time in Craft | Time on Jobsite */}
      <View style={{ flexDirection: 'row', borderBottom: '1px solid #333' }}>
        <View style={{ flex: 2, borderRight: '1px solid #333', paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Job Title:</Text>
          <Text style={{ fontSize: 11, fontWeight: 'bold' }}>{statement.jobTitle || '-'}</Text>
        </View>
        <View style={{ flex: 1, borderRight: '1px solid #333', paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Time in Craft:</Text>
          <Text style={{ fontSize: 11, fontWeight: 'bold' }}>{statement.timeInCraft || '-'}</Text>
        </View>
        <View style={{ flex: 1, paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Time on Jobsite:</Text>
          <Text style={{ fontSize: 11, fontWeight: 'bold' }}>{statement.timeOnJobsite || '-'}</Text>
        </View>
      </View>

      {/* If images exist, show large — like handwritten witness scan */}
      {hasImages ? (
        <View style={{ padding: 6 }}>
          {witImgs.map((img, i) => {
            const imageUrl = img?.file_name
              ? `https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=${encodeURIComponent(
                  `https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`
                )}`
              : null;
            return imageUrl ? (
              <Image key={i} src={imageUrl} style={{ width: '100%', height: 500, objectFit: 'contain', marginBottom: 6 }} />
            ) : null;
          })}
        </View>
      ) : (
        <View style={{ padding: 8 }}>
          <View style={{ marginBottom: 6 }}>
            <Text style={{ fontSize: 10, color: '#555', marginBottom: 2 }}>Witness Statement:</Text>
            <Text style={{ fontSize: 11 }}>{statement.description || '-'}</Text>
          </View>
          <View>
            <Text style={{ fontSize: 10, color: '#555', marginBottom: 2 }}>Supervisor Statement:</Text>
            <Text style={{ fontSize: 11 }}>{statement.supervisorstatement || '-'}</Text>
          </View>
        </View>
      )}

      {/* Bottom: Statement Witness | Signature | Date */}
      <View style={{ flexDirection: 'row', borderTop: '1px solid #333' }}>
        <View style={{ flex: 1, borderRight: '1px solid #333', paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Statement Witness:</Text>
          <Text style={{ fontSize: 11, fontWeight: 'bold' }}>{statement.name || '-'}</Text>
        </View>
        <View style={{ flex: 1, borderRight: '1px solid #333', paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Signature:</Text>
          {witnessSignatureImgs?.[index]?.map((sig, sigIndex) => (
            <Image key={sigIndex} src={sig.preview?.base64_data} style={{ width: 120, height: 30, objectFit: 'contain', marginTop: 2 }} />
          ))}
        </View>
        <View style={{ flex: 1, paddingHorizontal: 6, paddingVertical: 4 }}>
          <Text style={{ fontSize: 10, color: '#555' }}>Date:</Text>
          <Text style={{ fontSize: 11, fontWeight: 'bold' }}>{statement.date || '-'}</Text>
        </View>
      </View>
    </View>
    );
  })}
</View>
      {/* Photo Information Sheet — side-by-side: fields LEFT, images RIGHT */}
<View style={[styles.section, styles.borderTop]}>
  {data?.photoStatements?.map((photo, index) => {
    const photoImgs = data?.photoStatementImgs?.[index] || [];
    const imgUrls = photoImgs
      .map(img => img?.file_name
        ? `https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=${encodeURIComponent(
            `https://hub2.ntactops.com/ntact/files/forms_files/${img.file_name}`
          )}`
        : null)
      .filter(Boolean);

    return (
    <View key={index} style={{ border: '1px solid #333', marginBottom: 0 }}>
      {/* Title row */}
      <View style={{ borderBottom: '1px solid #333', paddingVertical: 5, backgroundColor: '#f3f4f6' }}>
        <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'center' }}>Photo Information Sheet</Text>
      </View>

      {/* Side-by-side: Details LEFT | Images RIGHT */}
      <View style={{ flexDirection: 'row' }}>
        {/* LEFT — Details table */}
        <View style={{ width: '40%', borderRight: '1px solid #333' }}>
          <View style={{ borderBottom: '1px solid #999', paddingHorizontal: 6, paddingVertical: 4 }}>
            <Text style={{ fontSize: 10, color: '#555' }}>Photo No.</Text>
            <Text style={{ fontSize: 12, fontWeight: 'bold' }}>{photo.photoNo || '-'}</Text>
          </View>
          <View style={{ borderBottom: '1px solid #999', paddingHorizontal: 6, paddingVertical: 4 }}>
            <Text style={{ fontSize: 10, color: '#555' }}>Photo Date:</Text>
            <Text style={{ fontSize: 12, fontWeight: 'bold' }}>{photo.photoDate || '-'}</Text>
          </View>
          <View style={{ borderBottom: '1px solid #999', paddingHorizontal: 6, paddingVertical: 4 }}>
            <Text style={{ fontSize: 10, color: '#555' }}>Time of Day:</Text>
            <Text style={{ fontSize: 12, fontWeight: 'bold' }}>
              {photo.timeOfDay
                ? new Date(`1970-01-01T${photo.timeOfDay}:00`).toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true,
                  })
                : '-'}
            </Text>
          </View>
          <View style={{ borderBottom: '1px solid #999', paddingHorizontal: 6, paddingVertical: 4 }}>
            <Text style={{ fontSize: 10, color: '#555' }}>Location:</Text>
            <Text style={{ fontSize: 12, fontWeight: 'bold' }}>{photo.location || '-'}</Text>
          </View>
          <View style={{ borderBottom: '1px solid #999', paddingHorizontal: 6, paddingVertical: 4, minHeight: 40 }}>
            <Text style={{ fontSize: 10, color: '#555', textAlign: 'center' }}>Brief Description:</Text>
            <Text style={{ fontSize: 9, textAlign: 'center' }}>(Provide direction of photo)</Text>
            <Text style={{ fontSize: 11, marginTop: 2 }}>{photo.description || ''}</Text>
          </View>
          <View style={{ borderBottom: '1px solid #999', paddingHorizontal: 6, paddingVertical: 4, minHeight: 30 }}>
            <Text style={{ fontSize: 10, color: '#555' }}>Notes:</Text>
            <Text style={{ fontSize: 11 }}>{photo.notes || ''}</Text>
          </View>
          <View style={{ paddingHorizontal: 6, paddingVertical: 4 }}>
            <Text style={{ fontSize: 10, color: '#555' }}>Photographer:</Text>
            <Text style={{ fontSize: 12, fontWeight: 'bold' }}>{photo.photographer || '-'}</Text>
          </View>
        </View>

        {/* RIGHT — Photo images in grid, 2 per row */}
        <View style={{ width: '60%', flexDirection: 'row', flexWrap: 'wrap', padding: 4, alignContent: 'flex-start' }}>
          {imgUrls.length > 0 ? (
            imgUrls.map((url, i) => (
              <View key={i} style={{ width: '50%', padding: 3 }}>
                <Image
                  src={url}
                  style={{
                    width: '100%',
                    height: 190,
                    objectFit: 'cover',
                    borderWidth: 1,
                    borderColor: '#ccc',
                  }}
                />
              </View>
            ))
          ) : (
            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', minHeight: 100 }}>
              <Text style={{ fontSize: 11, color: '#999' }}>No photo attached</Text>
            </View>
          )}
        </View>
      </View>
    </View>
    );
  })}
{data?.motorVehicleReport && (
  <>
    {/* DRIVER INFO */}
    <View style={[styles.section, styles.borderTop]} break>
      <Text style={styles.sectionTitle}>Driver Information</Text>

      <View style={styles.row}>
        <View style={styles.column}>
          <Text style={styles.label}>Driver Name</Text>
          <Text style={styles.value}>{data.motorVehicleReport.driverName || ''}</Text>
        </View>
        <View style={styles.column}>
          <Text style={styles.label}>Approved Driver</Text>
          <Text style={styles.value}>{data.motorVehicleReport.isDriverApproved || ''}</Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={styles.column}>
          <Text style={styles.label}>License Number</Text>
          <Text style={styles.value}>{data.motorVehicleReport.licenseNumber || ''}</Text>
        </View>
        <View style={styles.column}>
          <Text style={styles.label}>Issuing State</Text>
          <Text style={styles.value}>{data.motorVehicleReport.issuingState || ''}</Text>
        </View>
   <View style={styles.column}>
  <Text style={styles.label}>License Expiration</Text>
  <Text style={styles.value}>
    {data.motorVehicleReport.licenseExpiration &&
    !isNaN(new Date(data.motorVehicleReport.licenseExpiration).getTime())
      ? new Date(data.motorVehicleReport.licenseExpiration).toLocaleDateString()
      : ''}
  </Text>
</View>

      </View>
    </View>

    {/* VEHICLE INFO */}
<View style={[styles.section, styles.borderTop]} wrap={false}>
  <Text style={styles.sectionTitle}>Vehicle Information</Text>

  {/* Vehicle Type Row */}
  <View
    style={{
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      marginVertical: 8,
    }}
  >
    <View style={{ width: '32%' }}>
      <Text style={styles.label}>Vehicle Type</Text>
      <Text style={styles.value}>
        {[
          data.motorVehicleReport.vehicleType.ntactVehicle && 'NTACT Vehicle',
          data.motorVehicleReport.vehicleType.ntactLeased && 'NTACT Leased',
          data.motorVehicleReport.vehicleType.mobileEquipment && 'Mobile Equipment',
        ]
          .filter(Boolean)
          .join(', ') || ''}
      </Text>
    </View>
  </View>

  {/* Make / Model / Unit Row */}
  <View
    style={{
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      marginVertical: 8,
    }}
  >
    <View style={{ width: '32%' }}>
      <Text style={styles.label}>Make</Text>
      <Text style={styles.value}>{data.motorVehicleReport.vehicleDetails.make || ''}</Text>
    </View>

    <View style={{ width: '32%' }}>
      <Text style={styles.label}>Model</Text>
      <Text style={styles.value}>{data.motorVehicleReport.vehicleDetails.model || ''}</Text>
    </View>

    <View style={{ width: '32%' }}>
      <Text style={styles.label}>Unit #</Text>
      <Text style={styles.value}>{data.motorVehicleReport.vehicleDetails.unitNumber || ''}</Text>
    </View>
  </View>

  {/* Serial / Damage Estimate Row */}
  <View
    style={{
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      marginVertical: 8,
    }}
  >
    <View style={{ width: '32%' }}>
      <Text style={styles.label}>Serial #</Text>
      <Text style={styles.value}>{data.motorVehicleReport.vehicleDetails.serialNumber || ''}</Text>
    </View>

    <View style={{ width: '32%' }}>
      <Text style={styles.label}>Damage Estimate</Text>
      <Text style={styles.value}>{data.motorVehicleReport.vehicleDetails.damageEstimate || ''}</Text>
    </View>

    <View style={{ width: '32%' }}>
      <Text style={styles.label}>Additional Info</Text>
      <Text style={styles.value}>{data.motorVehicleReport.vehicleDetails.additionalInfo || ''}</Text>
    </View>
  </View>
</View>

    {/* INCIDENT DETAILS */}
   <View style={[styles.section, styles.borderTop]}>
  <Text style={styles.sectionTitle}>Incident Details</Text>

  {/* Weather */}
  <View style={styles.row} wrap={false}>
    <View style={styles.column}>
      <Text style={styles.label}>Weather Conditions</Text>
      <Text style={styles.value}>
        {data.motorVehicleReport.incidentDetails.weatherConditions || ''}
      </Text>
    </View>
  </View>

  {/* Speed */}
  <View style={styles.row} wrap={false}>
    <View style={styles.column}>
      <Text style={styles.label}>Speed - Employee (MPH)</Text>
      <Text style={styles.value}>
        {data.motorVehicleReport.incidentDetails.speed.employee || ''}
      </Text>
    </View>

    <View style={styles.column}>
      <Text style={styles.label}>Speed - Other (MPH)</Text>
      <Text style={styles.value}>
        {data.motorVehicleReport.incidentDetails.speed.other || ''}
      </Text>
    </View>

    <View style={styles.column}>
      <Text style={styles.label}>Speed - Posted (MPH)</Text>
      <Text style={styles.value}>
        {data.motorVehicleReport.incidentDetails.speed.posted || ''}
      </Text>
    </View>
  </View>

  {/* ❗ NON-EMPLOYEE INJURIES (FIXED) */}
  <View style={styles.fieldContainer} wrap={false}>
    <Text style={styles.label}>Non-Employee Injuries</Text>
    <Text style={styles.textarea}>
      {data.motorVehicleReport.incidentDetails.nonEmployeeInjuries || ''}
    </Text>
  </View>

  {/* ❗ PROPERTY DAMAGE (FIXED) */}
  <View style={styles.fieldContainer} wrap={false}>
    <Text style={styles.label}>Non-Employee Property Damage</Text>
    <Text style={styles.textarea}>
      {data.motorVehicleReport.incidentDetails.propertyDamage || ''}
    </Text>
  </View>

  {/* ❗ INCIDENT DESCRIPTION (FIXED) */}
  <View style={styles.fieldContainer} wrap={false}>
    <Text style={styles.label}>Incident Description</Text>
    <Text style={styles.textarea}>
      {data.motorVehicleReport.incidentDetails.incidentDescription || ''}
    </Text>
  </View>
</View>


    {/* DIAGRAM IMAGE */}

  {data?.motorVehicleReport?.diagramimg?.file_name && (
  <View style={[styles.section, styles.borderTop]} break>
    <Text style={styles.sectionTitle}>Diagram / Illustration</Text>

    <Image
      src={`https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=${encodeURIComponent(
        `https://hub2.ntactops.com/ntact/files/forms_files/${data.motorVehicleReport.diagramimg.file_name}`
      )}`}
      style={{
        width: 120,
        height: 120,
        resizeMode: "contain",
        borderRadius: 4,
      }}
    />

    {data.motorVehicleReport.diagramimg.file_name && (
      <Text style={styles.imageFilename}>
        {data.motorVehicleReport.diagramimg.file_name}
      </Text>
    )}
  </View>
)}

  </>
)}



</View>
    </Page>
  </Document>
    );

    // React Component for Accident/Incident Report Modal
    const AIFFormModal = ({ setFormView,formView, rowData }) => {
    
 const [loader,setLoader]=useState(false)
      const formRef = useRef(null);
      const [pdfBlob, setPdfBlob] = useState(null);
const [imagesarray,setImagesArray]=useState([])
const [diagramImages, setDiagramImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [employeeStatementImgs, setEmployeeStatementImgs] = useState({});
const [witnessStatementImgs, setWitnessStatementImgs] = useState({});
const [photoStatementImgs, setPhotoStatementImgs] = useState({});
const [witnessSignatureImgs, setWitnessSignatureImgs] = useState({});
const [employeeSignatureImgs, setEmployeeSignatureImgs] = useState({});
const[empsignimg,setEmpSignimg]=useState(null)
const[supimg,setsupimg]=useState(null)
  // State to manage whether the modal is open or closed
  const [isModalOpen, setIsModalOpen] = useState(false);
      // Extract relevant data from rowData
      const data = rowData?.json_data[0] || {};
      const employeeName = rowData?.emp_name || 'N/A';
      const jobNumber = data.jobNumber || 'N/A';
      const filledDate = rowData?.filled_date || 'N/A';
      const incidentData = {
        incidentdate: data.incidentdate || 'N/A',
        department: data.department || { selectedValue: 'N/A' },
        clientbeennotified: data.clientbeennotified || { selectedValue: 'N/A' },
        injuredside: data.injuredside || { selectedValue: 'N/A' },
      };
  // Function to open the modal with a specific image
  const openModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };
const convertTo12Hour = (time24) => {
  const [hours, minutes] = time24.split(':');
  let hour = parseInt(hours, 10);
  const period = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12; // Convert 0 to 12 for 12 AM, and handle 13-23
  return `${hour}:${minutes} ${period}`;
};
  // Function to close the modal
  const closeModal = () => {
    setSelectedImage(null); // Clear the selected image
    setIsModalOpen(false);
  };

     const generatePDF = async () => {
  try {
    setLoader(true); // 👈 start loading
    console.log(photoStatementImgs, 'emppp');

    const blob = await import('@react-pdf/renderer').then(({ pdf }) =>
      pdf(
        <PDFDocument
          data={data}
          diagramImages={diagramImages}
          imagesarray={imagesarray || []}
          employeeSignatureImgs={employeeSignatureImgs}
          witnessSignatureImgs={witnessSignatureImgs}
          supimg={supimg}
          empsignimg={empsignimg}
        />
      ).toBlob()
    );

    setPdfBlob(blob);
    const pdfUrl = URL.createObjectURL(blob);
    window.open(pdfUrl, '_blank');
  } catch (error) {
    console.error('Error generating PDF:', error);
  } finally {
    setLoader(false); // 👈 stop loading (always runs)
  }
};




const fetchimgs = async () => {
  try {
    console.log("🟢 fetchimgs() started");
    setLoader(true);

    // Combine all image-related objects
    const allImageEntries = [
      // ...Object.entries(data.employeeStatementImgs || {}),
      // ...Object.entries(data.witnessStatementImgs || {}),
      // ...Object.entries(data.photoStatementImgs || {}),
      ...Object.entries(data.employeeStatementSigs || {}),
      ...Object.entries(data.witnessStatementSigs || {}),
    ];

    console.log("🧩 Combined image entries:", allImageEntries);

    // Extract file names safely (supporting both arrays and single objects)
    const filenamesArray = allImageEntries.flatMap(([_, files]) => {
      if (Array.isArray(files)) {
        return files.map(file => file.file_name);
      } else if (files && typeof files === "object") {
        return [files.file_name];
      } else {
        return [];
      }
    });
  if (data.employeeSignImg?.file_name) {
      filenamesArray.push(data.employeeSignImg.file_name);
      console.log("✍️ Added employee signature:", data.employeeSignImg.file_name);
    }
    if (data.supervisorSignImg?.file_name) {
      filenamesArray.push(data.supervisorSignImg.file_name);
      console.log("👨‍💼 Added supervisor signature:", data.supervisorSignImg.file_name);
    }
    console.log("📁 Filenames collected:", filenamesArray);

    // Add diagram image if present"diagramimg
    // if (data.motorVehicleReport?.diagramimg?.file_name) {
    //   filenamesArray.push(data.motorVehicleReport.diagramimg.file_name);
    //   console.log("🗺️ Added diagram image:", data.motorVehicleReport.diagramimg.file_name);
    // }else{
    //   console.log(data?.motorVehicleReport.diagramimg,'hereeee')
    //   console.log("🗺️ No diagram image found");
    // }

    if (filenamesArray.length === 0) {
      console.log("⚠️ No filenames found — skipping image fetch");
      return;
    }

    // Build query params
    const queryParams = filenamesArray
      .map(name => `filenames=${encodeURIComponent(name)}`)
      .join("&");

    console.log("🔗 Query Params:", queryParams);

    // Fetch all images at once
    const res = await api.get(`/v1/documents/view-multiple?${queryParams}`);

    console.log("📬 API Response:", res);

    if (res.status === 200) {
      const imageUrls = res.images || [];
      console.log("🖼️ Retrieved image URLs:", imageUrls);

      let index = 0;

      const buildState = (imgMap, label) => {
        const stateObj = {};
        console.log(`⚙️ Building state for ${label}:`, imgMap);

        for (const [id, files] of Object.entries(imgMap)) {
          // ✅ Always use an array
          const fileArray = Array.isArray(files)
            ? files
            : files && typeof files === "object"
            ? [files]
            : [];

          stateObj[id] = fileArray.map(() => {
            const preview = imageUrls[index++];
            return {
              file: null,
              preview: preview || null,
              uploaded: !!preview,
            };
          });
        }

        console.log(`✅ Built state for ${label}:`, stateObj);
        return stateObj;
      };

      // Update component states safely
      // setEmployeeStatementImgs(buildState(data.employeeStatementImgs || {}, "employeeStatementImgs"));
      // setWitnessStatementImgs(buildState(data.witnessStatementImgs || {}, "witnessStatementImgs"));
      // setPhotoStatementImgs(buildState(data.photoStatementImgs || {}, "photoStatementImgs"));
      setEmployeeSignatureImgs(buildState(data.employeeStatementSigs || {}, "employeeStatementSigs"));
      setWitnessSignatureImgs(buildState(data.witnessStatementSigs || {}, "witnessStatementSigs"));

      // Handle diagram image separately
      if (data.motorVehicleReport?.diagramimg?.file_name) {
        const diagramIndex = filenamesArray.findIndex(
          name => name === data.motorVehicleReport.diagramimg.file_name
        );
        const diagramUrl = imageUrls[diagramIndex] || null;
        console.log("🖋️ Diagram URL:", diagramUrl);
        setDiagramImages(diagramUrl ? [diagramUrl] : []);
      }
 if (data.employeeSignImg?.file_name) {
        const empIndex = filenamesArray.findIndex(
          name => name === data.employeeSignImg.file_name
        );
        const empUrl = imageUrls[empIndex] || null;
        console.log("✍️ Employee Sign URL:", empUrl);
        setEmpSignimg(empUrl);
      }

      if (data.supervisorSignImg?.file_name) {
        const supIndex = filenamesArray.findIndex(
          name => name === data.supervisorSignImg.file_name
        );
        const supUrl = imageUrls[supIndex] || null;
        console.log("👨‍💼 Supervisor Sign URL:", supUrl);
        setsupimg(supUrl);
      }
      console.log("🎉 All images processed successfully");
    } else {
      console.warn("⚠️ Non-200 response:", res.status);
    }
  } catch (error) {
    console.error("❌ Error fetching images:", error);
  } finally {
    setLoader(false);
    console.log("🔚 fetchimgs() completed");
  }
};


      useEffect(() => {
        if (formRef.current) {
          formRef.current.scrollTop = 0;
        }
      
      }, []);
      useEffect(()=>{
 setImagesArray([])
         fetchimgs()  
   
        
 
      },[])

      const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
          setFormView(false);
        }
      };
const ORIGINAL_BASE_URL =
  "https://hub2.ntactops.com/ntact/files/forms_files/";

const PROXY_URL =
  "https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=";

const withProxy = (url) =>
  url ? PROXY_URL + encodeURIComponent(url) : null;


      return (<>
        <div onClick={handleBackdropClick} className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="relative w-full max-w-4xl flex flex-col justify-center items-center p-6 bg-white rounded-lg border border-gray-300 shadow-md overflow-y-auto custom-scrollbar max-h-[95vh]">
            <div className="w-full flex justify-between items-end">
              <button
                onClick={generatePDF}
                className="bg-red-800 text-white px-4 py-1 rounded hover:bg-green-600"
              >
                Print
              </button>
              <button
                onClick={() => setFormView(false)}
                className="text-gray-600 hover:text-black"
              >
                <CloseIcon />
              </button>
            </div>

            <div ref={formRef} className="w-[90%]  mx-auto overflow-y-auto custom-scrollbar p-4">
              {/* Form Header */}
              <div className="border-b border-gray-700 pb-2 mb-4">
                <div className="flex flex-col w-full justify-center items-center">
                  <img src={NtactLogo} alt="NTACT Logo" className='w-24 h-24' />
                  <div>
                    <h2 className="text-lg font-semibold text-[#900]">Accident/Incident Investigation Form</h2>
                    <h6 className='text-[#71717A] text-xs font-normal'>NTACT Operations - Must be completed within 24 hours</h6>
                  </div>
                  <div className="mr-24"></div>
                </div>
              </div>


              {/* Basic Info Card */}
              {/* <div className="mb-4 bg-gray-50 p-4 rounded-lg shadow-sm">
                <p className="text-sm font-inter font-semibold text-center bg-gray-200 p-2 mb-2">BASIC INFO</p>
                <div className="grid grid-cols-3 gap-4">
                  <div className="border border-[#9CA3AF] p-1">
                    <p className="text-sm font-inter font-semibold text-left">Employee:</p>
                    <p className="text-left font-inter p-1 px-2">{employeeName}</p>
                    <hr className="border-t border-[#9CA3AF]" />
                  </div>
                  <div className="border border-[#9CA3AF] p-1">
                    <p className="text-sm font-inter font-semibold text-left">Job #:</p>
                    <p className="text-left font-inter p-1 px-2">{jobNumber}</p>
                    <hr className="border-t border-[#9CA3AF]" />
                  </div>
                  <div className="border border-[#9CA3AF] p-1">
                    <p className="text-sm font-inter font-semibold text-left">Date:</p>
                    <p className="text-left font-inter p-1 px-2">{filledDate}</p>
                    <hr className="border-t border-[#9CA3AF]" />
                  </div>
                </div>
              </div> */}
              <div>
                <div className="flex gap-6 mb-6">
          <div className="flex-1">
            <label className="block font-bold mb-2 text-left">
              Name of Employee
            </label>
            <div
              className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left"
            >
              {data?.employeename}
            </div>
          </div>
          <div className="flex-1">
            <label className="block font-bold mb-2 text-left">
              Employee/Badge #
            </label>
            <div
              className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left"
            >
              {data?.employeebadge}
            </div>
          </div>
          <div className="flex-1">
            <label className="block font-bold mb-2 text-left">
              Phone Number
            </label>
            <div
              className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left"
            >
              {data?.phonenumber}
            </div>
          </div>
        </div>
         <div className="flex gap-6 mb-6">
          <div className="flex-1">
            <label className="block font-bold mb-2 text-left">
              Address
            </label>
            <div
              className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left"
            >
              {data.address}
            </div>
          </div>
          <div className="flex-1">
            <label className="block font-bold mb-2 text-left">
              City
            </label>
            <div
              className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left"
            >
              {data.city}
            </div>
          </div>
          <div className="flex-1">
            <label className="block font-bold mb-2 text-left">
              State
            </label>
            <div
              className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left"
            >
              {data.state}
            </div>
          </div>
        </div>
              </div>
              <div className="flex gap-6 mb-6">
  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Zip
    </label>
    <div className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left">
      {data.zipcode || "-"}
    </div>
  </div>

  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Time of Incident:
    </label>
<div className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left">
  {data.incidentdate
    ? new Date(data.incidentdate).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    : "-"}
</div>


  </div>
</div>
<div className="flex gap-6 mb-6">
  <div className="flex-1">
    <div className="flex flex-col gap-2  px-4 py-3">
      <div className="block font-bold mb-2 text-left">
        Department
      </div>
      <div className="flex flex-col items-start gap-3">
       {data.department?.values.map((option) => {
  const isSelected = data.department.selectedValue === option;
  return (
    <div key={option} className="flex items-center gap-2 cursor-default">
      <div
        className={`w-4 h-4 rounded-full border flex items-center justify-center ${
                    isSelected ? 'bg-[#18181B]  border-[#cbd5e1]' : 'bg-gray-300'
          }`}
        >
          {isSelected &&  <div className="w-2 h-2 rounded-full bg-gray-300'" />}
      </div>
      <span className="text-[15px] font-inter text-gray-900">{option}</span>
    </div>
  );
})}

      </div>
    </div>
  </div>
</div>
<div className="flex gap-6 mb-6">
  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Job Title
    </label>
    <div className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left">
      {data.jobtitle || "-"}
    </div>
  </div>

  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Project Number
    </label>
    <div className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left">
      {data.projectnumber || "-"}
    </div>
  </div>

  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Project Location
    </label>
    <div className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left">
      {data.projectlocation || "-"}
    </div>
  </div>
</div>
<div className="flex gap-6 mb-6">
  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Client
    </label>
    <div className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left">
      {data.client || "-"}
    </div>
  </div>

  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Weather Condition
    </label>
    <div className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left">
      {data.wheathercondition || "-"}
    </div>
  </div>

  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Direct Supervisor
    </label>
    <div className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 text-left">
      {data.directsupervisor || "-"}
    </div>
  </div>
</div>
<div className="flex gap-6 mb-6">
  <div className="flex-1">
    <div className="flex flex-col gap-2 px-4 py-3">
      <div className="block font-bold mb-2 text-left">
        Client Been Notified
      </div>
  <div className="flex flex-col items-start gap-3">
  {data.clientbeennotified?.values.map((option) => {
    const isSelected = data.clientbeennotified.selectedValue === option;
    return (
      <div key={option} className="flex items-center gap-2 cursor-default">
        <div
          className={`w-4 h-4 rounded-full border flex items-center justify-center ${
                      isSelected ? 'bg-[#18181B]  border-[#cbd5e1]' : 'bg-gray-300'
          }`}
        >
          {isSelected &&  <div className="w-2 h-2 rounded-full bg-gray-300'" />}
        </div>
        <span className="text-[15px] font-inter text-gray-900">
          {option}
        </span>
      </div>
    );
  })}
</div>

    </div>
  </div>
</div>
{/* classifications */}
<div className="flex-1">
  <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
    <div className="block font-bold mb-2 text-left">
      Classification (Check all that apply)
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 items-start">
{data.damages?.options.map((option) => {
  const isChecked = data.damages.selectedValues.includes(option);
  return (
    <label
      key={option}
      className="flex items-center gap-2 cursor-default text-start"
    >
      <input
        type="checkbox"
        value={option}
        checked={isChecked}
        disabled
        className="accent-[rgba(24,24,27,1)] w-4 h-4"
      />
      <span className="text-[15px] font-inter text-gray-900">{option}</span>
    </label>
  );
})}


    </div>
  </div>
</div>
<div className="flex-1">
  <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
    <div className="block font-bold mb-2 text-left">
      Injured Side
    </div>
<div className="flex flex-col flex-wrap gap-4">
  {data.injuredside?.options.map((option) => {
    const isSelected = data.injuredside.selectedValue === option;
    return (
      <div
        key={option}
        className="flex items-center gap-2 cursor-default"
      >
        <div
          className={`w-4 h-4 rounded-full border flex items-center justify-center ${
            isSelected ? 'bg-[#18181B]  border-[#cbd5e1]' : 'bg-gray-300'
          }`}
        >
          {isSelected && (
            <div className="w-2 h-2 rounded-full bg-gray-300'" />
          )}
        </div>
        <span className="text-[15px] font-inter text-gray-900">{option}</span>
      </div>
    );
  })}
</div>


  </div>
</div>

<div className="flex-1">
  <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
    <div className="block font-bold mb-2 text-left">
      Body Parts Injured (Check all that apply)
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 items-start">
  {data.bodypartsinjuried?.options.map((option) => (
  <label
    key={option}
    className="flex items-center gap-2 cursor-default"
  >
    <input
      type="checkbox"
      value={option}
      checked={data.bodypartsinjuried.selectedValues.includes(option)}
      disabled
      className="accent-[rgba(24,24,27,1)] w-4 h-4"
    />
    <span className="text-[15px] font-inter text-gray-900">{option}</span>
  </label>
))}

    </div>
  </div>
</div>
<div className="bg-white shadow-md rounded-lg p-6 border border-gray-200 mb-4">
  {/* Section: Checkboxes */}
   <div className="text-[15px] text-start font-semibold mb-4">
    {"Post-Accident Drug & Alcohol Testing"}
  </div>
  <div className="flex flex-wrap gap-12 border-t border-gray-200 pt-4">
    {/* Post-Accident UA */}
    <div className="flex flex-col gap-2">
      <div className="font-semibold text-gray-800">Post-Accident UA</div>
      <div className="flex gap-6">
        {data.postaccidentua.options.map((option) => (
          <label key={option} className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              value={option}
              checked={
                Array.isArray(data.postaccidentua?.selectedValues) &&
                data.postaccidentua.selectedValues.includes(option)
              }
              disabled
              className="accent-gray-900 w-4 h-4"
            />
            <span className="text-sm text-gray-900">{option}</span>
          </label>
        ))}
      </div>
    </div>

    {/* Test Type */}
    <div className="flex flex-col gap-2">
      <div className="font-semibold text-gray-800">Test Type</div>
      <div className="flex gap-6">
        {data.testtype?.selectedValue}
      </div>
    </div>
  </div>

  {/* Section: Inputs */}
  <div className="flex gap-6 mt-6">
    {/* Facility */}
    <div className="flex-1">
      <label className="block text-sm  text-start font-semibold text-gray-700 mb-1">
        Facility
      </label>
      <input
        type="text"
        value="Sample Facility"
        disabled
        className="w-full rounded-md border border-gray-300 bg-gray-100 text-sm p-2"
      />
    </div>

    {/* Collector */}
    <div className="flex-1">
      <label className="block text-sm  text-start font-semibold text-gray-700 mb-1">
        Collector
      </label>
      <input
        type="text"
        value="Sample Collector"
        disabled
        className="w-full rounded-md border border-gray-300 bg-gray-100 text-sm p-2"
      />
    </div>
  </div>
</div>
{/* <div className="flex flex-col gap-6 mb-6">
  <div className="flex-1">
    <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
      <label className="block font-bold mb-2 text-left">Type of Injury</label>
      <select
        value={data.injurytype.selectedvalue}
        disabled
        className="w-full p-2 border border-gray-300 rounded-md text-[15px] font-inter text-gray-900"
      >
        <option value="" disabled>
          Select an injury type
        </option>
        {data.injurytype.options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  </div>

  <div className="flex-1">
    <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
      <label className="block font-bold mb-2 text-left">Incident Cause</label>
      <select
        value={data.incidentcause.selectedvalue}
        disabled
        className="w-full p-2 border border-gray-300 rounded-md text-[15px] font-inter text-gray-900"
      >
        <option value="" disabled>
          Select an incident cause
        </option>
        {data.incidentcause.options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  </div>

  <div className="flex-1">
    <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
      <label className="block font-bold mb-2 text-left">Description of Accident / Incident</label>
      <textarea
        value={data.descriptionofincident}
        disabled
        rows={8}
        placeholder="Enter the details of what happened"
        className="w-full p-2 border border-gray-300 rounded-md text-[15px] font-inter text-gray-900 resize-none"
      />
    </div>
  </div>
</div>

<div className="flex-1">
  <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
    <label className="block font-bold mb-2 text-left">
     Witness Statement
    </label>
    <textarea
      value={data.witnessstatement}
      disabled
      rows={8}
      placeholder={"Enter the witness statement"}
      className="w-full p-2 border border-gray-300 rounded-md text-[15px] font-inter text-gray-900 resize-none"
    />
  </div>
</div> */}




<div className="flex gap-6 mb-6">
  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Employee Name (Print)
    </label>
    <input
      type="text"
      placeholder="Employee Name"
      value={data.employeenameprint || ""}
      disabled
      className="w-full p-2 border border-gray-300 rounded-md"
    />
  </div>
  {data.employeenameprintsignature&&<div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Signature
    </label>
    <input
      type="text"
      placeholder="Signature"
      value={data.employeenameprintsignature || ""}
      disabled
      className="w-full p-2 border border-gray-300 rounded-md"
    />
  </div>}

  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Date:
    </label>
    <input
      type="text"
      value={
        data.employeenameprintsignaturedate
          ? new Date(data.employeenameprintsignaturedate + "T00:00:00").toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
          : ""
      }
      disabled
      placeholder="MM-DD-YYYY"
      className="w-full p-2 border border-gray-300 rounded-md"
    />
  </div>
</div>
<div>
  {empsignimg?.base64_data&& <div className="mt-4 mb-2">
        <label className="font-semibold text-gray-700 mb-1 text-left block">
          Employee Signature
        </label>
        <div className="flex flex-wrap gap-4">
      
            <div
          
              className="w-24 h-24 border border-gray-300 rounded overflow-hidden"
            >
              <img
                src={empsignimg?.base64_data}
                alt={`Employe`}
                onClick={() => openModal(empsignimg)}
                className="object-contain w-full h-full cursor-pointer"
              />
            </div>
      
        </div>
      </div>}
</div>
<div className="flex gap-6 mb-6">
  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Supervisor Name (Print)
    </label>
    <input
      type="text"
      placeholder="Supervisor Name"
      value={data.supervisornameprint || ""}
      disabled
      className="w-full p-2 border border-gray-300 rounded-md"
    />
  </div>

  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Signature
    </label>
    <input
      type="text"
      placeholder="Signature"
      value={data.supervisorprintsignature || ""}
      disabled
      className="w-full p-2 border border-gray-300 rounded-md"
    />
  </div>

  <div className="flex-1">
    <label className="block font-bold mb-2 text-left">
      Date:
    </label>
    <input
      type="text"
      value={
        data.supervisorprintsignaturedate
          ? new Date(data.supervisorprintsignaturedate + "T00:00:00").toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
          : ""
      }
      disabled
      placeholder="MM-DD-YYYY"
      className="w-full p-2 border border-gray-300 rounded-md"
    />
  </div>
</div>
{supimg?.base64_data&& <div className="mt-4">
        <label className="font-semibold text-gray-700 mb-1 text-left block">
         Supervisor Signature
        </label>
        <div className="flex flex-wrap gap-4">
      
            <div
          
              className="w-24 h-24 border border-gray-300 rounded overflow-hidden"
            >
              <img
                src={supimg?.base64_data}
                alt={`supe`}
                onClick={() => openModal(supimg)}
              className="w-28 h-28 object-cover rounded border mb-2 transition-transform duration-200 hover:scale-110"

              />
            </div>
      
        </div>
      </div>}
<div className="text-start font-semibold text-base mb-2 mt-2">Incident Details</div>

<div className="flex flex-col gap-6">
  {/* <div className="flex-1">
    <div className="flex items-center gap-2">
      <input
        type="checkbox"
        checked={data?.enterManually}
        disabled
        className="accent-[rgba(24,24,27,1)] w-4 h-4"
      />
      <span className="text-[15px] font-inter text-gray-900">Enter Manually</span>
    </div>
  </div> */}

  <div className="flex-1 mb-2">
    <div className="bg-[#E4E4E7] text-start rounded-xl px-4 py-4">
      <label className="block text-sm font-medium text-black mb-4">
        Accident Description
      </label>
      <div className="text-sm font-semibold text-[#0A0A0A] mb-1">
        Detailed description of what happened
      </div>
      <div className="w-full bg-[#F3F3F5] text-sm text-gray-700 font-inter p-3 rounded-md">
        {data?.descriptionofincident || "-"}
      </div>
    </div>
  </div>

  <div className="flex-1 mb-2">
    <div className="bg-[#E4E4E7] text-start rounded-xl px-4 py-4">
      <label className="block text-sm font-medium text-black mb-4">
        Incident Causes
      </label>
      <div className="text-sm font-semibold text-[#0A0A0A] mb-1">
        What caused this incident?
      </div>
      <div className="w-full bg-[#F3F3F5] text-sm text-gray-700 font-inter p-3 rounded-md">
        {data?.incidentDescription || "-"}
      </div>
    </div>
  </div>

  <div className="flex-1 mb-2">
    <div className="bg-[#E4E4E7] text-start rounded-xl px-4 py-4">
      <label className="block text-sm font-medium text-black mb-4">
        Incident Summary
      </label>
      <div className="text-sm font-semibold text-[#0A0A0A] mb-1">
        Summary of incident
      </div>
      <div className="w-full bg-[#F3F3F5] text-sm text-gray-700 font-inter p-3 rounded-md">
        {data?.incidentsummary || "-"}
      </div>
    </div>
  </div>
</div>

<div className="text-start font-semibold text-base mb-4 mt-4">Witness Information</div>

<div className="flex flex-col gap-6">
  {<div className="bg-white border border-gray-200 rounded-xl px-4 py-4">
    <div className="text-sm text-start font-semibold text-gray-800 mb-2">
      Were there any witnesses?
    </div>
    <div className="flex flex-col gap-4">
      <label className="flex items-center gap-2">
        <input
          type="radio"
          checked={data?.anyWitness === "Yes"}
          disabled
          className="accent-[rgba(24,24,27,1)]"
        />
        <span className="text-sm text-gray-900 font-inter">Yes</span>
      </label>
        <label className="flex items-center gap-2">
        <input
          type="radio"
          checked={data?.anyWitness === "No"}
          disabled
          className="accent-[rgba(24,24,27,1)]"
        />
        <span className="text-sm text-gray-900 font-inter">No</span>
      </label>
    </div>
  </div>}

  <div className="flex flex-col text-start gap-4">
    {(data?.witnessCards || []).map((witness, i) => (
      <div
        key={i}
        className="relative bg-white border border-gray-200 rounded-xl px-4 py-4"
      >
        <div className="text-sm font-semibold text-gray-800 mb-3">
          Witness {i + 1}
        </div>

        <div className="mb-3">
          <label className="block text-sm text-gray-700 mb-1">Name</label>
          <div className="w-full bg-gray-100 text-sm text-gray-700 font-inter p-3 rounded-md">
            {witness.name || "-"}
          </div>
        </div>

        <div>
          <label className="block text-sm text-gray-700 mb-1">Phone Number</label>
          <div className="w-full bg-gray-100 text-sm text-gray-700 font-inter p-3 rounded-md">
            {witness.phone || "-"}
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

{/* <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
  <div className="font-bold text-left">Attachments: Check all that apply</div>
  <div className="flex flex-wrap gap-6">
    {data.attachments.options.map((option) => (
      <label key={option} className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          value={option}
          checked={data.attachments.selectedvalues.includes(option)}
          disabled
          className="accent-black w-4 h-4"
        />
        <span className="text-[15px] font-inter text-gray-900">{option}</span>
      </label>
    ))}
  </div>
</div> */}
<div className="flex flex-col gap-4 border-t border-gray-200 px-4 py-3">
  <div className="font-bold text-left">Attachments: Check all that apply</div>

  <div className="flex flex-col gap-6">
    {data.attachments.options.map((option) => {
      const files = data.attachments.Files?.[option] || [];

      return (
        <div key={option} className="flex flex-col gap-2">
          {/* Checkbox */}
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              value={option}
              checked={data.attachments.selectedvalues.includes(option)}
              disabled
              className="accent-black w-4 h-4"
            />
            <span className="text-[15px] font-inter text-gray-900">{option}</span>
          </label>

          {/* File Previews / Links */}
{files.length > 0 && (
  <div className="ml-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
    {files.map((file, idx) => {
      const fileName = file.file_name;

      const originalUrl =
        "https://hub2.ntactops.com/ntact/files/forms_files/" + fileName;

      const finalUrl =
        "https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=" +
        encodeURIComponent(originalUrl);

      const isImage = /\.(jpg|jpeg|png|gif|webp|heic|bmp)$/i.test(fileName);
      const isPDF = /\.pdf$/i.test(fileName);

      return (
        <div
          key={idx}
          className="flex flex-col items-center p-3 border rounded shadow-sm hover:shadow-md transition cursor-pointer bg-white"
        >
          {isImage && (
            <img
              src={finalUrl}
              alt={fileName}
               onClick={() => {
      setSelectedImage({
               preview: finalUrl, // always a string URL/base64
      });
      setIsModalOpen(true);
    }}
              className="w-28 h-28 object-cover rounded border mb-2 transition-transform duration-200 hover:scale-110"
      
            />
          )}

          {isPDF && (
            <a
              href={finalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded bg-red-100 border border-red-300 mb-2">
                <span className="text-red-600 font-bold text-sm">PDF</span>
              </div>
              <span className="text-xs text-gray-700 text-center break-all">
                {fileName}
              </span>
            </a>
          )}

          {!isImage && !isPDF && (
            <a
              href={finalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded bg-gray-100 border mb-2">
                <span className="text-gray-700 font-semibold text-sm">FILE</span>
              </div>
              <span className="text-xs text-gray-700 text-center break-all">
                {fileName}
              </span>
            </a>
          )}
        </div>
      );
    })}
  </div>
)}

        </div>
      );
    })}
  </div>
</div>


<div className="flex-1">
  <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
    <label className="block font-bold mb-2 text-left">
      Incident Summary
    </label>
    <textarea
      value={data.witnessSummary}
      rows={5}
      placeholder="Enter a brief summary of the incident"
      className="w-full p-2 border border-gray-300 rounded-md text-[15px] font-inter text-gray-900 resize-none"
      disabled
    />
  </div>
</div>
 
<div className='my-2 font-semibold text-lg text-left'>Statement of Employee</div>
{data.employeeStatements.map((statement, index) => (
  <div
    key={index}
    className="p-6 mb-6 rounded-sm border border-gray-300 bg-white shadow-sm"
  >
    <h3 className="font-bold text-lg mb-4">Employee Statement {index + 1}</h3>

    {/* Row 1 */}
    <div className="flex gap-6 mb-4">
      {['jobTitle', 'timeInCraft', 'timeOnJobsite'].map((field) => (
        <div key={field} className="flex-1 flex flex-col">
          <label className="font-semibold text-gray-700 mb-1 text-left">
            {field === 'jobTitle' ? 'Job Title' : field === 'timeInCraft' ? 'Time in Craft' : 'Time on Jobsite'}
          </label>
          <div className="border border-gray-300 rounded-md p-2 text-gray-900 text-left" style={{ minHeight: '38px' }}>
            {(field === 'timeInCraft' || field === 'timeOnJobsite') && statement[field]
              ? statement[field]
              : statement[field] || '-'}
          </div>
        </div>
      ))}
    </div>

    {/* Row 2 - Description */}
    <div className="mb-4 flex flex-col">
      <label className="font-semibold text-gray-700 mb-1 text-left">
        Employee Statement
      </label>
      <div
        className="border border-gray-300 rounded-md p-2 text-gray-900 text-left whitespace-pre-wrap"
        style={{ minHeight: '80px', whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}
      >
        {statement.description || '-'}
      </div>
    </div>

    {/* Row 3 */}
    <div className="flex gap-6">
      {['name',  'date'].map((field) => (
        <div key={field} className="flex-1 flex flex-col">
          <label className="font-semibold text-gray-700 mb-1 text-left">
            {field.charAt(0).toUpperCase() + field.slice(1)}
          </label>
          <div
            className="border border-gray-300 rounded-md p-2 text-gray-900 text-left"
            style={{ minHeight: '38px' }}
          >
            {statement[field] || '-'}
          </div>
        </div>
      ))}
    </div>
 {employeeSignatureImgs?.[index]?.length > 0 && (
      <div className="mt-4">
        <label className="font-semibold text-gray-700 mb-1 text-left block">
          Employee Signature
        </label>
        <div className="flex flex-wrap gap-4">
          {employeeSignatureImgs[index].map((sig, sigIndex) => (
            <div
              key={sigIndex}
              className="w-28 h-28 border border-gray-300 rounded overflow-hidden"
            >
              <img
                src={sig.preview?.base64_data}
                alt={`Employee ${index + 1} - Signature ${sigIndex + 1}`}
                onClick={() => openModal(sig)}
              className="w-28 h-28 object-cover rounded border mb-2 transition-transform duration-200 hover:scale-110"

              />
            </div>
          ))}
        </div>
      </div>
    )}
    {/* Row 4 - Images */}
    {/* {employeeStatementImgs?.[index]?.length > 0 && (
      <div className="mt-4">
        <label className="font-semibold text-gray-700 mb-1 text-left block">
          Uploaded Images
        </label>
        <div className="flex flex-wrap gap-4">
          {employeeStatementImgs[index].map((img, imgIndex) => (
            <div key={imgIndex} className="w-28 h-28 border border-gray-300 rounded overflow-hidden">
              <img
                src={img.preview?.base64_data}
                alt={`Employee ${index + 1} - Image ${imgIndex + 1}`}
                 onClick={() => openModal(img)}
             className="w-28 h-28 object-cover rounded border mb-2 transition-transform duration-200 hover:scale-110"

              />
            </div>
          ))}
        </div>
      </div>
    )} */}
   {data?.employeeStatementImgs?.[index]?.length > 0 && (
  <div className="mt-4">
    <label className="font-semibold text-gray-700 mb-1 text-left block">
      Uploaded Images
    </label>

    <div className="flex flex-wrap gap-4">
      {data.employeeStatementImgs[index].map((img, imgIndex) => {
        console.log(img, "imagefromemployee");

        const fileName = img.file_name;

        const originalUrl = fileName
          ? ORIGINAL_BASE_URL + fileName
          : null;

        const proxiedUrl = withProxy(originalUrl);

        return (
          <div
            key={imgIndex}
            className="w-28 h-28 border border-gray-300 rounded overflow-hidden"
          >
            <img
              src={proxiedUrl}
              alt={`Employee ${index + 1} - Image ${imgIndex + 1}`}
              onClick={() =>
                openModal({
                  ...img,
                  preview: proxiedUrl, // modal expects preview
                })
              }
              className="w-28 h-28 object-cover rounded border transition-transform duration-200 hover:scale-110 cursor-pointer"
            />
          </div>
        );
      })}
    </div>
  </div>
)}


  </div>
))}

<div className='my-2 font-semibold text-lg text-left'>Witness Statement</div>
{data.witnessStatements.map((statement, index) => (
  <div
    key={index}
    className="p-6 mb-6 rounded-sm border border-gray-300 bg-white shadow-sm"
  >
    <h3 className="font-bold text-lg mb-4">Witness Statement {index + 1}</h3>

    {/* Row 1 */}
    <div className="flex gap-6 mb-4">
      {['jobTitle', 'timeInCraft', 'timeOnJobsite'].map((field) => (
        <div key={field} className="flex-1 flex flex-col">
          <label className="font-semibold text-gray-700 mb-1 text-left">
            {field === 'jobTitle'
              ? 'Job Title'
              : field === 'timeInCraft'
              ? 'Time in Craft'
              : 'Time on Jobsite'}
          </label>
          <div
            className="border border-gray-300 rounded-md p-2 text-gray-900 text-left"
            style={{ minHeight: '38px' }}
          >
            {(field === 'timeInCraft' || field === 'timeOnJobsite') && statement[field]
              ? statement[field]
              : statement[field] || '-'}
          </div>
        </div>
      ))}
    </div>

    {/* Row 2 - Description */}
    <div className="mb-4 flex flex-col">
      <label className="font-semibold text-gray-700 mb-1 text-left">
      Witness Statement
      </label>
      <div
        className="border border-gray-300 rounded-md p-2 text-gray-900 text-left whitespace-pre-wrap"
        style={{ minHeight: '80px', whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}
      >
        {statement.description || '-'}
      </div>
    </div>
  <div className="mb-4 flex flex-col">
      <label className="font-semibold text-gray-700 mb-1 text-left">
      Supervisor Statement
      </label>
      <div
        className="border border-gray-300 rounded-md p-2 text-gray-900 text-left whitespace-pre-wrap"
        style={{ minHeight: '80px', whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}
      >
        {statement.supervisorstatement || '-'}
      </div>
    </div>
    {/* Row 3 */}
    <div className="flex gap-6">
      {['name',  'date'].map((field) => (
        <div key={field} className="flex-1 flex flex-col">
          <label className="font-semibold text-gray-700 mb-1 text-left">
            {field.charAt(0).toUpperCase() + field.slice(1)}
          </label>
          <div
            className="border border-gray-300 rounded-md p-2 text-gray-900 text-left"
            style={{ minHeight: '38px' }}
          >
            {statement[field] || '-'}
          </div>
        </div>
      ))}
    </div>
 {witnessSignatureImgs?.[index]?.length > 0 && (
      <div className="mt-4">
        <label className="font-semibold text-gray-700 mb-1 text-left block">
          Witness Signatures
        </label>
        <div className="flex flex-wrap gap-4">
          {witnessSignatureImgs[index].map((sig, sigIndex) => (
            <div
              key={sigIndex}
              className="w-28 h-28 border border-gray-300 rounded overflow-hidden"
            >
              <img
                src={sig.preview?.base64_data}
                alt={`Witness ${index + 1} - Signature ${sigIndex + 1}`}
                onClick={() => openModal(sig)}
        className="w-28 h-28 object-cover rounded border mb-2 transition-transform duration-200 hover:scale-110"

              />
            </div>
          ))}
        </div>
      </div>
    )}
    {/* Row 4 - Images */}
    {/* {witnessStatementImgs?.[index]?.length > 0 && (
      <div className="mt-4">
        <label className="font-semibold text-gray-700 mb-1 text-left block">
          Uploaded Images
        </label>
        <div className="flex flex-wrap gap-4">
          {witnessStatementImgs[index].map((img, imgIndex) => (
            <div
              key={imgIndex}
              className="w-28 h-28 border border-gray-300 rounded overflow-hidden"
            >
              <img
                src={img.preview?.base64_data}
              
                alt={`Witness ${index + 1} - Image ${imgIndex + 1}`}
                       onClick={() => openModal(img)}
           className="w-28 h-28 object-cover rounded border mb-2 transition-transform duration-200 hover:scale-110"

              />
            </div>
          ))}
        </div>
      </div>
    )} */}
 {data?.witnessStatementImgs?.[index]?.length > 0 && (
  <div className="mt-4">
    <label className="font-semibold text-gray-700 mb-1 text-left block">
      Uploaded Images
    </label>

    <div className="flex flex-wrap gap-4">
      {data.witnessStatementImgs[index].map((img, imgIndex) => {
        const fileName = img.file_name;

        const originalUrl = fileName
          ? ORIGINAL_BASE_URL + fileName
          : null;

        const proxiedUrl = withProxy(originalUrl);

        return (
          <div
            key={imgIndex}
            className="w-28 h-28 border border-gray-300 rounded overflow-hidden"
          >
            <img
              src={proxiedUrl}
              alt={`Witness ${index + 1} - Image ${imgIndex + 1}`}
              onClick={() =>
                openModal({
                  ...img,
                  preview: proxiedUrl, // modal compatibility
                })
              }
              className="w-28 h-28 object-cover rounded border transition-transform duration-200 hover:scale-110 cursor-pointer"
            />
          </div>
        );
      })}
    </div>
  </div>
)}

  </div>
))}

<div className='my-2 font-semibold text-lg text-left'>Photo Information Sheet</div>
{/* <div className="flex justify-center items-center gap-2 p-4">
  {imagesarray.map((image, index) => (
    <img
      key={index}
      src={image.base64_data}
      alt={image.filename}
      className="max-w-full rounded-lg shadow-md w-52 h-52 "
    />
  ))}
</div> */}
<div className="flex justify-center items-center gap-2 p-4 flex-wrap">
  {imagesarray.map((image, index) => (
    <img
      key={index}
      src={image.base64_data}
      alt={image.filename}
      className="max-w-full rounded-lg shadow-md w-52 h-52 cursor-pointer transition-transform duration-200 hover:scale-105"
      onClick={() => openModal(image)}
    />
  ))}
</div>
      {/* Full Screen Modal */}
  {isModalOpen && selectedImage && (
  <div
    className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50 p-4"
    onClick={closeModal}
  >
    <div
      className="relative bg-white rounded-lg shadow-xl p-2 md:p-4 max-w-4xl max-h-[90vh] flex justify-center items-center"
      onClick={(e) => e.stopPropagation()}
    >
      <img
        src={
          typeof selectedImage.preview === "string"
            ? selectedImage.preview // API / proxied URL
            : selectedImage.preview?.base64_data || selectedImage.base64_data // upload
        }
        alt=""
        className="max-w-full max-h-full object-contain"
      />

      {/* Close Button */}
      <button
        className="absolute top-2 right-2 text-white bg-gray-800 rounded-full w-8 h-8 flex items-center justify-center text-xl font-bold opacity-75 hover:opacity-100 transition-opacity"
        onClick={closeModal}
        aria-label="Close modal"
      >
        &times;
      </button>
    </div>
  </div>
)}

{data.photoStatements.map((photo, index) => (
  <div
    key={index}
    className="p-6 mb-6 rounded-lg border border-gray-300 bg-white shadow-sm"
  >
    <h3 className="font-bold text-lg mb-4">Photo Statement {index + 1}</h3>

    {/* Row 1 */}
    <div className="flex gap-6 mb-4">
      {['photoNo', 'photoDate'].map((field) => (
        <div key={field} className="flex-1 flex flex-col">
          <label className="font-semibold text-gray-700 mb-1 text-left">
            {field === 'photoNo' ? 'Photo No' : 'Photo Date'}
          </label>
          <div className="border border-gray-300 rounded-md p-2 text-gray-900 text-left" style={{ minHeight: '38px' }}>
            {photo[field] || '-'}
          </div>
        </div>
      ))}
    </div>

    {/* Row 2 */}
    <div className="flex gap-6 mb-4">
      {['timeOfDay', 'location'].map((field) => (
        <div key={field} className="flex-1 flex flex-col">
          <label className="font-semibold text-gray-700 mb-1 text-left">
            {field === 'timeOfDay' ? 'Time of Day' : 'Location'}
          </label>
          <div className="border border-gray-300 rounded-md p-2 text-gray-900 text-left" style={{ minHeight: '38px' }}>
            {field === 'timeOfDay' && photo[field]
              ? convertTo12Hour(photo[field])
              : photo[field] || '-'}
          </div>
        </div>
      ))}
    </div>

    {/* Row 3 - Description */}
    <div className="mb-4 flex flex-col">
      <label className="font-semibold text-gray-700 mb-1 text-left">
        Brief Description (Provide directions of photo)
      </label>
      <div
        className="border border-gray-300 rounded-md p-2 text-gray-900 text-left whitespace-pre-wrap"
        style={{ minHeight: '80px', whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}
      >
        {photo.description || '-'}
      </div>
    </div>

    {/* Row 4 - Notes */}
    <div className="mb-4 flex flex-col">
      <label className="font-semibold text-gray-700 mb-1 text-left">Notes</label>
      <div
        className="border border-gray-300 rounded-md p-2 text-gray-900 text-left whitespace-pre-wrap"
        style={{ minHeight: '50px', whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}
      >
        {photo.notes || '-'}
      </div>
    </div>

    {/* Row 5 - Photographer */}
    <div className="flex flex-col">
      <label className="font-semibold text-gray-700 mb-1 text-left">Photographer</label>
      <div
        className="border border-gray-300 rounded-md p-2 text-gray-900 text-left"
        style={{ minHeight: '38px' }}
      >
        {photo.photographer || '-'}
      </div>
    </div>

    {/* Row 6 - Uploaded Images */}
  {data?.photoStatementImgs?.[index]?.length > 0 && (
  <div className="mt-4">
    <label className="font-semibold text-gray-700 mb-1 text-left block">
      Uploaded Images
    </label>

    <div className="flex flex-wrap gap-4">
      {data.photoStatementImgs[index].map((img, imgIndex) => {
        const fileName = img.file_name;

        const originalUrl = fileName
          ? ORIGINAL_BASE_URL + fileName
          : null;

        const proxiedUrl = withProxy(originalUrl);

        return (
          <div
            key={imgIndex}
            className="w-28 h-28 border border-gray-300 rounded overflow-hidden"
          >
            <img
              src={proxiedUrl}
              alt={`Photo Statement ${index + 1} - Image ${imgIndex + 1}`}
              onClick={() => {
                setSelectedImage({
                  ...img,
                  preview: proxiedUrl, // modal compatibility
                });
                setIsModalOpen(true);
              }}
              className="w-28 h-28 object-cover rounded border transition-transform duration-200 hover:scale-110 cursor-pointer"
            />
          </div>
        );
      })}
    </div>
  </div>
)}


    {/* {photoStatementImgs?.[index]?.length > 0 && (
      <div className="mt-4">
        <label className="font-semibold text-gray-700 mb-1 text-left block">
          Uploaded Images
        </label>
        <div className="flex flex-wrap gap-4">
          {photoStatementImgs[index].map((img, imgIndex) => (
            <div
              key={imgIndex}
              className="w-28 h-28 border border-gray-300 rounded overflow-hidden"
            >
              <img
               onClick={() => {
                setSelectedImage(img)
              setIsModalOpen(true)
              }}
                src={img.preview?.base64_data}
                alt={`Photo Statement ${index + 1} - Image ${imgIndex + 1}`}
           className="w-28 h-28 object-cover rounded border mb-2 transition-transform duration-200 hover:scale-110"

              />
            </div>
          ))}
        </div>
      </div>
    )} */}
  </div>
))}

{data?.motorVehicleReport && (
  <>
    {/* DRIVER INFO */}
    <div className="border p-6 text-start rounded-lg shadow-sm bg-white my-4">
      <div className="text-md font-bold mb-4">Driver Information</div>
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block font-semibold mb-1">Driver Name</label>
          <div className="p-2 border rounded bg-gray-50">{data.motorVehicleReport.driverName}</div>
        </div>

        <div className="col-span-2 flex items-center gap-4">
          <span className="font-medium">Is Driver on NTACT Approved Driver List:</span>
          <span>{data.motorVehicleReport.isDriverApproved}</span>
        </div>

        <div>
          <label className="block font-semibold mb-1">Driver License #</label>
          <div className="p-2 border rounded bg-gray-50">{data.motorVehicleReport.licenseNumber}</div>
        </div>

        <div>
          <label className="block font-semibold mb-1">Issuing State</label>
          <div className="p-2 border rounded bg-gray-50">{data.motorVehicleReport.issuingState}</div>
        </div>
<div>
  <label className="block font-semibold mb-1">License Expiration</label>
  <div className="p-2 border rounded bg-gray-50">
    {data.motorVehicleReport.licenseExpiration &&
    !isNaN(new Date(data.motorVehicleReport.licenseExpiration).getTime())
      ? new Date(data.motorVehicleReport.licenseExpiration).toLocaleDateString()
      : ''}
  </div>
</div>

      </div>
    </div>

    {/* VEHICLE INFO */}
    <div className="border p-6 rounded-lg text-start shadow-sm bg-white my-4">
      <div className="text-md font-bold mb-4">Vehicle Information</div>

      <label className="block font-semibold mb-1">Vehicle Type</label>
      <div className="flex gap-4 mb-4">
        {data.motorVehicleReport.vehicleType.ntactVehicle && <span>NTACT Vehicle</span>}
        {data.motorVehicleReport.vehicleType.ntactLeased && <span>NTACT Leased Vehicle</span>}
        {data.motorVehicleReport.vehicleType.mobileEquipment && <span>Mobile Equipment</span>}
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div>
          <label className="block font-semibold mb-1">Make</label>
          <div className="p-2 border rounded bg-gray-50">{data.motorVehicleReport.vehicleDetails.make}</div>
        </div>
        <div>
          <label className="block font-semibold mb-1">Model</label>
          <div className="p-2 border rounded bg-gray-50">{data.motorVehicleReport.vehicleDetails.model}</div>
        </div>
        <div>
          <label className="block font-semibold mb-1">Unit #</label>
          <div className="p-2 border rounded bg-gray-50">{data.motorVehicleReport.vehicleDetails.unitNumber}</div>
        </div>
        <div>
          <label className="block font-semibold mb-1">Serial #</label>
          <div className="p-2 border rounded bg-gray-50">{data.motorVehicleReport.vehicleDetails.serialNumber}</div>
        </div>
        <div>
          <label className="block font-semibold mb-1">Damage Estimate</label>
          <div className="p-2 border rounded bg-gray-50">{data.motorVehicleReport.vehicleDetails.damageEstimate}</div>
        </div>
      </div>
    </div>

    {/* INCIDENT DETAILS */}
    <div className="border p-6 rounded-lg shadow-sm text-start bg-white my-4">
      <div className="text-md font-bold mb-4">Incident Details</div>

      <div className="mb-4">
        <label className="block font-semibold mb-1">Describe Weather Conditions</label>
        <div className="p-2 border rounded bg-gray-50">{data.motorVehicleReport.incidentDetails.weatherConditions}</div>
      </div>

      <div className="mb-4">
        <label className="block font-semibold mb-1">Approximate Vehicle Speed</label>
        <div className="flex gap-4">
          <div className="flex items-center gap-2">
            <span className="font-medium">Employee:</span>
            <span>{data.motorVehicleReport.incidentDetails.speed.employee} MPH</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-medium">Other:</span>
            <span>{data.motorVehicleReport.incidentDetails.speed.other} MPH</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-medium">Posted:</span>
            <span>{data.motorVehicleReport.incidentDetails.speed.posted} MPH</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block font-semibold mb-1">Non-Employee Injuries</label>
          <div className="p-2 border rounded bg-gray-50 whitespace-pre-wrap">
            {data.motorVehicleReport.incidentDetails.nonEmployeeInjuries}
          </div>
        </div>
        <div>
          <label className="block font-semibold mb-1">Non-Employee's Property Damage or Loss</label>
          <div className="p-2 border rounded bg-gray-50 whitespace-pre-wrap">
            {data.motorVehicleReport.incidentDetails.propertyDamage}
          </div>
        </div>
      </div>

      <div className="flex gap-4 mb-4">
        {/* Description of Incident */}
        <div className="flex-1">
          <label className="block font-semibold mb-1">Description of Incident</label>
          <div className="p-2 border rounded bg-gray-50 whitespace-pre-wrap">
            {data.motorVehicleReport.incidentDetails.incidentDescription}
          </div>
        </div>

        {/* Uploaded Diagram */}
        <div className="flex-1">
          <label className="block font-semibold mb-1">Diagram/Illustration</label>
        {data?.motorVehicleReport?.diagramimg?.file_name && (
  <img
    src={`https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=${encodeURIComponent(
      `https://hub2.ntactops.com/ntact/files/forms_files/${data.motorVehicleReport.diagramimg.file_name}`
    )}`}
    alt="Diagram"
    className="max-w-full rounded-lg shadow-md w-52 h-52 cursor-pointer transition-transform duration-200 hover:scale-105"
    onClick={() =>
      openModal({
        preview: {
          base64_data: `https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=${encodeURIComponent(
            `https://hub2.ntactops.com/ntact/files/forms_files/${data.motorVehicleReport.diagramimg.file_name}`
          )}`,
        },
      })
    }
  />
)}

        </div>
      </div>
    </div>
  </>
)}

            </div>
          </div>
        </div>
             <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
        </>
      );
    };
export default AIFFormModal